import { BankIntegrationVendor } from '../types/bank-integration-vendor';
import fincredibleSessionService from './fincredible-session.service';
import sessionService from './session.service';
import { ISessionService } from './interfaces/session.interface';
import { IBankService } from './interfaces/bank.interface';
import { fincredibleBankService } from './fincredible-bank.service';
import bankService from './bank.service';

export function getSessionService(vendor: BankIntegrationVendor): ISessionService {
	if (vendor === 'FINCREDIBLE') {
		return fincredibleSessionService;
	}
	return sessionService;
}

export function getBankService(vendor: BankIntegrationVendor): IBankService {
	if (vendor === 'FINCREDIBLE') {
		return fincredibleBankService;
	}
	return bankService;
}
